<mat-toolbar *ngIf="displayTestBanner" style="height: 4%; background-color: coral; color: white; justify-content: center; font-style: italic;">DEBUG</mat-toolbar>
<router-outlet *ngIf="displayComponent"></router-outlet>